
  <template><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M9.429 3.844V5.25h5.142V3.844A.84.84 0 0 1 15.43 3c.464 0 .857.387.857.844V5.25h1.428C18.964 5.25 20 6.27 20 7.5v11.25c0 1.266-1.036 2.25-2.286 2.25H6.286C5 21 4 20.016 4 18.75V7.5c0-1.23 1-2.25 2.286-2.25h1.428V3.844A.84.84 0 0 1 8.571 3c.465 0 .858.387.858.844M5.714 9.75v9c0 .316.25.563.572.563h11.428c.286 0 .572-.247.572-.563v-9z"/></svg></template>
  <style scoped>
    svg {
      display: inline-block;
      vertical-align: baseline;
      margin-bottom: -2px;
    }
  </style>